'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = passthrough;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _except = require('except');

var _except2 = _interopRequireDefault(_except);

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

function passthrough() {
  var _ref = arguments[0] === undefined ? {} : arguments[0];

  var _ref$force = _ref.force;
  var force = _ref$force === undefined ? [] : _ref$force;
  var _ref$omit = _ref.omit;
  var omit = _ref$omit === undefined ? ['children'] : _ref$omit;
  var _ref$omitKnownPropTypes = _ref.omitKnownPropTypes;
  var omitKnownPropTypes = _ref$omitKnownPropTypes === undefined ? true : _ref$omitKnownPropTypes;

  return function decorator(component) {
    (0, _invariant2['default'])(!component.prototype.passthrough, '@passthrough must be applied to a class with no `passthrough` property');

    if (omitKnownPropTypes) {
      omit.push.apply(omit, Object.keys(component.propTypes || {}));
    }

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = force[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var prop = _step.value;

        var i = omit.indexOf(prop);
        if (i != -1) {
          omit.splice(i, 1);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator['return']) {
          _iterator['return']();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    component.prototype.passthrough = function passthrough() {
      return (0, _except2['default'])(this.props, omit);
    };
  };
}

module.exports = exports['default'];